import { Badge } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

export const ForYouBadge = () => {
  const { t } = useTranslation('@mc/next')
  return (
    <Badge kind='primary' className='mc-ml-3 mc-text--uppercase mc-corners--1'>
      {t('nav.categories.forYou')}
    </Badge>
  )
}
